import React from "react";
import { Footer } from "../../Components/Footer/Footer";
import { Navbar } from "../../Components/Navbar/Navbar";
import img from "../../Components/Navbar/LogoNav.png";
import "./working.css";

export const Working = () => {
  return (
    <div className="working">
      <Navbar></Navbar>

      <div className="workLogo">
        <p className="workTxt"> We are working on this page!</p>

        <img src={img} alt="" />
      </div>
      <Footer></Footer>
    </div>
  );
};
